<template>
  <section>
    <!-- Menu -->
    <top-menu/>

    <!-- Loading from page -->
    <full-loading v-if="loadingList"/>

    <div class="page-wrapper-row full-height">
      <div class="page-wrapper-middle">
        <div class="page-container">
          <div class="page-content-wrapper">
            <!-- Page Head -->
            <div class="page-head">
              <div class="container padding-bottom-12">
                <!-- Title -->
                <div class="col-md-3 padding-null">
                  <div class="page-title offset-top-4">
                    <h1>Total de Acessos</h1>
                  </div>
                </div>
              </div>
            </div>

            <div class="page-content">
              <div class="container offset-top-20">
                <!-- Breadcrumb -->
                <ul class="page-breadcrumb breadcrumb breadcrumb-crud">
                  <li>
                    <a href="/dashboard">Dashboard</a>
                    <i class="fa fa-circle"></i>
                  </li>
                  <li>
                    <span class="breadcrumb-active">Total de Acessos</span>
                  </li>
                </ul>

                <!-- Table -->
                <div v-if="!loadingList && dataAccess.length" class="portlet light">
                  <div class="portlet-title">
                    <div class="caption">
                      <span
                        class="caption-subject font-blue bold uppercase">Quantidade total de empresas ({{
                          dataAccess.length
                        }})</span>
                    </div>
                  </div>

                  <div class="portlet-body contate-table offset-top-20">
                    <div class="table-scrollable table-scrollable-borderless">
                      <table class="table table-hover table-light table-icon">
                        <thead>
                        <tr>
                          <th> EMPRESA</th>
                          <th> NOME</th>
                          <th> DATA</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="a in dataAccess">
                          <td>{{ a.companyName }}</td>
                          <td>{{ a.name }}</td>
                          <td>{{ a.date }}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import swal from 'sweetalert';

import {
  APP_ACCESS
} from "../../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../../requestConfig";

export default {
  name: "total-access",
  components: {
    topMenu,
    fullLoading
  },
  data() {
    return {
      loadingList: true,
      dataAccess: ''
    }
  },
  methods: {
    getAccess() {
      this.loadingList = true;

      REQUEST_SERVICE.get(APP_ACCESS + "?t=kkkk")
        .then((response) => {
          this.dataAccess = response.data;
          this.loadingList = false;
        }).catch((reason) => {
        this.loadingList = false;
        reason.response.data.erros.map((value, index) => {
          swal("Aviso", value.value, "error");
        });
      });
    }
  },
  beforeMount() {
    this.getAccess();
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/totalAccess/totalAccess.vue